import React from 'react';
import { Trans } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import Checkbox from '@components/shared/Checkbox';
import Colors from '@components/shared/Colors';
import LinkTranslated from '@components/shared/LinkTranslated';
import { P } from '@components/shared/Typography';

type Props = {
  onClick: () => void;
  checked: boolean;
};

const Terms: React.FC<Props> = ({ onClick, checked }) => {
  const termsLink = 'https://www.iubenda.com/terms-and-conditions/80288176';
  const privacyLink = 'https://www.iubenda.com/privacy-policy/80288176';

  return (
    <>
      <CheckboxContainer data-testid="terms-checkbox" onClick={onClick}>
        <Checkbox checked={checked} style={{ marginRight: 15 }} />
        <PStyled>
          <Trans
            i18nKey="components.agree-terms"
            components={{
              a1: <LinkTranslated to={termsLink} targetBlank onClick={(e) => e.stopPropagation()} />,
              a2: <LinkTranslated to={privacyLink} targetBlank onClick={(e) => e.stopPropagation()} />
            }}
          />
        </PStyled>
      </CheckboxContainer>
    </>
  );
};

export default Terms;

const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  text-align: left;
`;

const PStyled = styled(P)`
  padding-top: 2px;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: ${Colors.navyBlue};

  @media (max-width: 768px) {
    font-size: 14px;
  }

  a {
    font-weight: bold;
    color: inherit;
  }
`;
